// extracted by mini-css-extract-plugin
export default {"employee":"employee_employee__4xWFM","name":"employee_name__fbIxP","phone":"employee_phone__F4APj","login":"employee_login__suHhJ","actions":"employee_actions__yMDEb"};